import type { HTMLAttributes, ReactNode } from "react";
import { injectCss } from "../core/injectCss";

const CSS = `
.js-status{
  display:inline-flex;align-items:center;gap:6px;font-family:var(--font-sans);
  font-size:var(--text-xs);font-weight:var(--weight-bold);line-height:1;
  padding:5px 11px;border-radius:var(--radius-pill);white-space:nowrap;
}
.js-status__dot{width:7px;height:7px;border-radius:50%;background:currentColor}
.js-status--taught{background:var(--status-taught-bg);color:var(--status-taught-fg)}
.js-status--upcoming{background:var(--status-upcoming-bg);color:var(--status-upcoming-fg)}
.js-status--leave{background:var(--status-leave-bg);color:var(--status-leave-fg)}
.js-status--absent{background:var(--status-absent-bg);color:var(--status-absent-fg)}
.js-status--deducted{background:var(--neutral-100);color:var(--text-muted)}
`;

export type ClassHourStatus = "taught" | "upcoming" | "leave" | "absent" | "deducted";

const LABELS: Record<ClassHourStatus, string> = {
  taught: "已上课",
  upcoming: "待上课",
  leave: "请假",
  absent: "缺勤",
  deducted: "已扣减",
};

export interface StatusPillProps extends HTMLAttributes<HTMLSpanElement> {
  status?: ClassHourStatus;
  label?: ReactNode;
  dot?: boolean;
}

export function StatusPill({ status = "upcoming", label, dot = true, className = "", ...rest }: StatusPillProps) {
  injectCss("js-status-css", CSS);
  return (
    <span className={["js-status", `js-status--${status}`, className].filter(Boolean).join(" ")} {...rest}>
      {dot && <span className="js-status__dot" />}
      {label || LABELS[status] || status}
    </span>
  );
}
